export function update(id, data) {
    return {
        type: 'COMPETITION_DATA',
        data,
        id
    };
}

export function bulk(data) {
    return {
        type: 'COMPETITIONS_DATA',
        data
    };
}
